/**
 * Shared "Transaction PIN" form field for every money-out flow
 * (withdraw, transfer, invest, repay, settle, deposit-pay, AutoInvest).
 *
 * The backend rejects these actions without a valid PIN:
 *   PIN_NOT_SET (403) — user must create one (Account → Transaction PIN)
 *   PIN_REQUIRED / PIN_INVALID / PIN_LOCKED (400/403)
 * so the field is required client-side to save a round-trip.
 */

import { TEXT } from "../constants/constants";

export const transactionPinField = {
  label: "Transaction PIN",
  field: "pin",
  type: TEXT,
  required: true,
  props: {
    type: "password",
    inputMode: "numeric",
    maxLength: 4,
    placeholder: "••••",
    helperText:
      "Your 4-digit transaction PIN. No PIN yet? Set one under Account → Transaction PIN.",
  },
};
